import { useEffect, useMemo, useState } from "react";
import { storeClient } from "../api/storeClient";

const getSessionId = () => {
  if (typeof window === "undefined") return "";
  const hash = window.location.hash || "";
  const queryStart = hash.indexOf("?");
  if (queryStart < 0) return "";
  const params = new URLSearchParams(hash.slice(queryStart + 1));
  return params.get("session_id") || "";
};

const formatGrant = (grant = {}) => {
  const parts = [];
  if (grant.credits_quick) parts.push(`${grant.credits_quick} × Szybka`);
  if (grant.credits_deep) parts.push(`${grant.credits_deep} × Głęboka`);
  if (grant.credits_followup) parts.push(`${grant.credits_followup} × Pytanie po analizie`);
  if (grant.access_symbols_days) parts.push(`Symbolika · ${grant.access_symbols_days} dni`);
  if (grant.access_trace_days) parts.push(`Ślad snów · ${grant.access_trace_days} dni`);
  if (grant.access_ai_days) parts.push(`Analizy AI · ${grant.access_ai_days} dni`);
  if (grant.access_deep_days) parts.push(`Głębokie odczyty · ${grant.access_deep_days} dni`);
  if (grant.access_all_days) parts.push(`Pełny dostęp · ${grant.access_all_days} dni`);
  return parts;
};

export const StorePaymentSuccessPage = () => {
  const sessionId = useMemo(getSessionId, []);
  const [state, setState] = useState({ loading: true, message: "Sprawdzam płatność…", result: null });

  useEffect(() => {
    let mounted = true;
    const confirm = async () => {
      if (!sessionId) {
        setState({ loading: false, message: "Brakuje identyfikatora płatności.", result: null });
        return;
      }
      const response = await storeClient.session(sessionId);
      if (!mounted) return;
      if (response?.ok) {
        setState({
          loading: false,
          message: response.already_consumed ? "Ta płatność była już zapisana wcześniej." : "Płatność zapisana. Pakiet został dodany do konta.",
          result: response,
        });
      } else {
        setState({ loading: false, message: response?.message || "Nie udało się potwierdzić płatności.", result: null });
      }
    };
    confirm();
    return () => { mounted = false; };
  }, [sessionId]);

  const grant = state.result?.order?.grant_snapshot || state.result?.grant?.applied || {};
  const grantParts = formatGrant(grant);

  return (
    <section className="mdStore mdPage" data-ui="store-payment-success">
      <div className="mdPage__inner mdStore__inner">
        <div className="mdStore__notice mdCard" data-ui="store-payment-card">
          <p className="mdPage__eyebrow">Płatność</p>
          <h1 className="mdPage__title">Pakiet <em>zapisany</em></h1>
          <p className="mdPage__subtitle">{state.message}</p>
          {grantParts.length > 0 && (
            <ul className="mdStore__grant" data-ui="store-payment-grant">
              {grantParts.map((part) => <li key={part}>{part}</li>)}
            </ul>
          )}
          <div className="mdRow" data-ui="store-payment-actions">
            <a className="mdBtn mdBtn--primary mdBtn--row" href="#/sklep">Wróć do sklepu</a>
            <a className="mdBtn mdBtn--row" href="#/pokoik">Przejdź do Pokoiku</a>
          </div>
        </div>
      </div>
    </section>
  );
};

export const StorePaymentCancelPage = () => (
  <section className="mdStore mdPage" data-ui="store-payment-cancel">
    <div className="mdPage__inner mdStore__inner">
      <div className="mdStore__notice mdCard" data-ui="store-payment-card">
        <p className="mdPage__eyebrow">Płatność</p>
        <h1 className="mdPage__title">Płatność <em>przerwana</em></h1>
        <p className="mdPage__subtitle">Nie zapisaliśmy żadnego pakietu. Możesz wrócić do sklepu i wybrać ofertę ponownie.</p>
        <div className="mdRow" data-ui="store-payment-actions">
          <a className="mdBtn mdBtn--primary mdBtn--row" href="#/sklep">Wróć do sklepu</a>
        </div>
      </div>
    </div>
  </section>
);
